import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../api';

import { CLIENT_URL } from '../../constants';

export const mnpApi = createApi({
  reducerPath: 'mnpApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Mnp'],
  endpoints: (builder) => ({
    sendMnpRequest: builder.mutation({
      query: (data) => ({
        url: 'mnp-requests/',
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        baseURL: CLIENT_URL,
      }),
    }),
    getMnpForm: builder.query({
      query: ({ lang }) => ({
        url: '/pages/mnp-development-page/',
        method: 'GET',
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
  }),
});

export const hooks = {
  useSendMnpRequest: mnpApi.useSendMnpRequestMutation,
  useGetMnpForm: mnpApi.useGetMnpFormQuery,
};

export default mnpApi;
